import { createFileRoute } from '@tanstack/react-router'
import { ContactTable } from '~/components/contacts/contact-table'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/contacts/')({
  component: ContactsIndex,
})

function ContactsIndex() {
  return <ContactTable />
}
